import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { useDebounce } from 'uikit';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimCalcWorkOrderChangeOtherDistributionGql } from '../../../WorkOrderChange/BimWorkOrderChangeEditDistribution/BimWorkOrderChangeDistributionQueries';

const requestId = 'bimCalcWorkOrderChangeOtherDistribution';

type TProps = {
    workOrderChangeCompositeIds: string | undefined;
    onCalculation: (items: any[]) => void;
    onError: () => void;
};

const toNumberOrNull = (value: string) => (value ? Number(value) : null);

// TODO: зарефакторить в будущем. пока вводим композитный ключ из
// workOrderChangeId_workOrderOtherPriceId_workOrderChangeOtherPriceId
export const useBimWorkOrderChangeOtherCalculation = (props: TProps) => {
    const dispatch = useDispatch();

    const { onCalculation, onError, workOrderChangeCompositeIds = '' } = props;

    const [workOrderChangeId, workOrderOtherPriceId, workOrderChangeOtherPriceId] =
        workOrderChangeCompositeIds.split('_');

    const [resetStoreData] = useResetStoreData({
        requestId,
    });

    const [calcData, calcStatus, , calcRequest] = useRequest({
        requestId,
        query: bimCalcWorkOrderChangeOtherDistributionGql,
        withEffect: false,
    });

    useEffect(() => {
        resetStoreData(undefined);
    }, [resetStoreData]);

    useEffect(() => {
        if (calcStatus === RequestStatus.SUCCESS && calcData?.bimCalcWorkOrderChangeOtherDistribution?.result) {
            onCalculation(
                calcData?.bimCalcWorkOrderChangeOtherDistribution?.data?.map((result) => ({
                    ...result,
                    savedWorkOrderObjetId: result?.workOrderObjectId,
                    workOrderObjectId: `${result?.workOrderObjectId}_${result?.workOrderChangeObjectId}`,
                })) || [],
            );

            resetStoreData(undefined);
        }
    }, [
        calcData?.bimCalcWorkOrderChangeOtherDistribution?.data,
        calcData?.bimCalcWorkOrderChangeOtherDistribution?.result,
        calcStatus,
        onCalculation,
        resetStoreData,
    ]);

    useEffect(() => {
        if (
            calcStatus === RequestStatus.ERROR ||
            (calcStatus === RequestStatus.SUCCESS && !calcData?.bimCalcWorkOrderChangeOtherDistribution?.result)
        ) {
            onError();
            resetStoreData(undefined);
        }
    }, [calcData?.bimCalcWorkOrderChangeOtherDistribution?.result, calcStatus, onError, resetStoreData]);

    const bimCalcWorkOrderChangeDistributionRequest = useCallback(
        (input: { includedCost: number; contractOtherCostId: number | undefined; ids: string[] }) => {
            // ключи прочих идут парой ${workOrderObjectId}_${workOrderChangeObjectId}
            const idsArray = input.ids.map((k) => ({
                workOrderObjectId: toNumberOrNull(k.split('_')[0]),
                workOrderChangeObjectId: toNumberOrNull(k.split('_')[1]),
            }));

            dispatch(
                calcRequest({
                    workOrderChangeId: Number(workOrderChangeId),
                    workOrderOtherPriceId: toNumberOrNull(workOrderOtherPriceId),
                    workOrderChangeOtherPriceId: toNumberOrNull(workOrderChangeOtherPriceId),
                    input: {
                        includedCost: input.includedCost,
                        contractOtherCostId: input.contractOtherCostId,
                        workOrderChangeObjectIds: idsArray,
                    },
                }),
            );
        },
        [calcRequest, dispatch, workOrderChangeId, workOrderChangeOtherPriceId, workOrderOtherPriceId],
    );

    const debouncedChange = useDebounce(bimCalcWorkOrderChangeDistributionRequest, 700);

    return {
        bimCalcWorkOrderChangeDistributionStatus: calcStatus,
        bimCalcWorkOrderChangeDistributionRequest: debouncedChange,
    };
};
